import {inject} from '@angular/core';
import {DialogService} from '../services/dialog/dialog.service';
import {AnnotationQuery} from '../queries/annotation.query';
import {AiChatService} from '../services/ai/ai-chat.service';
import {AnnotationService} from '../services/annotation/annotation.service';
import {TokenService} from '../services/token/token.service';
import {AppService} from '../services/app/app.service';
import {PanelService} from '../services/panel/panel.service';

export async function hasUnsavedChangesRouteGuard(): Promise<boolean> {
    const annotationQuery: AnnotationQuery = inject(AnnotationQuery);
    const annotationService: AnnotationService = inject(AnnotationService);
    const tokenService: TokenService = inject(TokenService);
    const dialogService: DialogService = inject(DialogService);
    const aiChatService: AiChatService = inject(AiChatService);
    const appService: AppService = inject(AppService);
    const panelService: PanelService = inject(PanelService);
    if (tokenService.isCurrentTokenValid()) {

        if (annotationQuery.getHasUnsavedAnnotationChanges()) {
            const discardChanges = await dialogService.showDiscardUnsavedChangesDialog();
            if (discardChanges) {
                annotationService.setHasUnsavedAnnotationChanges(false);
                return true;
            }

            return false;
        }

        if (appService.getHasUnsavedTagChanges()) {
            const discardChanges = await dialogService.showDiscardUnsavedTagChangesDialog();
            if (discardChanges) {
                appService.setHasUnsavedTagChanges(false);
                panelService.closeAll();
                return true;
            }

            return false;
        }

        if (aiChatService.getIsShowingAiChat()) {
            return await aiChatService.hideAiChatOverlay();
        }
    }
    return true;
}
